import { FFmpeg } from '@ffmpeg/ffmpeg';

class FfmpegInterop {
    private ffmpeg: FFmpeg | null = null;
    private ffmpegLoaded: boolean = false;

    public async loadFfmpegWasm(): Promise<void> {
        if (!this.ffmpeg) {
            this.ffmpeg = new FFmpeg();
        }
        if (!this.ffmpegLoaded) {
            await this.ffmpeg.load({
                coreURL: '/js/ffmpeg-core.js',
                wasmURL: '/js/ffmpeg-core.wasm',
            });
            this.ffmpegLoaded = true;
        }
    }

    public async normalizeAudioFromBytes(inputBytes: Uint8Array): Promise<Uint8Array> {
        if (!this.ffmpegLoaded || !this.ffmpeg) await this.loadFfmpegWasm();

        try {
            await this.ffmpeg.writeFile('input.webm', inputBytes);
            await this.ffmpeg.exec([
                '-i', 'input.webm',
                '-af', 'dynaudnorm',
                'output.mp3'
            ]);
            const outputData = await this.ffmpeg.readFile('output.mp3');
            if (outputData instanceof Uint8Array) return outputData;
            return null;
        } catch (e) {
            console.error("Unable to normalize audio")
            console.error(e);
            throw e;
        }
    }

    public async trimAudioFromBytes(inputBytes: Uint8Array, start: string, end: string): Promise<Uint8Array> {
        if (!this.ffmpegLoaded || !this.ffmpeg) await this.loadFfmpegWasm();

        try {
            await this.ffmpeg.writeFile('input.webm', inputBytes);

            await this.ffmpeg.exec([
                '-i', 'input.webm',
                '-ss', `${start}`,
                '-to', `${end}`,
                '-c:a', 'libmp3lame',
                'output.mp3'
            ]);

            const outputData = await this.ffmpeg.readFile('output.mp3');
            if (outputData instanceof Uint8Array) return outputData;
            return null;
        } catch (e) {
            console.error("Unable to trim audio")
            console.error(e);
            throw e;
        }
    }
}

const ffmpegInterop = new FfmpegInterop();

(window as any).ffmpegInterop = {
    loadFfmpegWasm: () => ffmpegInterop.loadFfmpegWasm(),
    normalizeAudioFromBytes: (inputBytes: Uint8Array) => ffmpegInterop.normalizeAudioFromBytes(inputBytes),
    trimAudioFromBytes: (inputBytes: Uint8Array, start: string, end: string) =>
        ffmpegInterop.trimAudioFromBytes(inputBytes, start, end),
};
